
export default {
  data: () => ({ errors: [] }),

  methods: {
    async refinePrevious() {
      this.errors = [];
      try {
        await this.$store.dispatch("productsSearch/showPrevious");
      } catch (error) {
        this.$bugsnag.notify(error);
        this.errors.push("Something went wrong...");
      }
    },
  },
};
